import React from 'react'
import Logo from '../../img/logo.jpg'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import classnames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import Flags from '../Flags'


    let ShowNavMobile = () => {
      let Nav = document.getElementById('NavMobile');
      Nav.classList.remove('hidden');
      Nav.classList.add('NavMobileMenu');
    }
    let CloseNavMobile = () => {
      let Nav = document.getElementById('NavMobile');
      Nav.classList.add('hidden');
      Nav.classList.remove('NavMobileMenu');
    }

export class Nav extends React.PureComponent {

  constructor(props) {
      super(props);
      this.state = {
        prevScrollpos: window.pageYOffset,
        visible: true
      };
    }
    handleScroll = () => {
      const { prevScrollpos } = this.state;
      const currentScrollPos = window.pageYOffset;
      const visible = prevScrollpos > window.pageYOffset;
    // prevScrollpos > currentScrollPos
      this.setState({
        prevScrollpos: currentScrollPos,
        visible
      });
    };
    componentDidMount() {
      window.addEventListener("scroll", this.handleScroll);
    }

  
  render() { 





  return (
       
    <div className={classnames("TopBar", {"TopBar--hidden": !this.state.visible})}>
            <div>
            <AnchorLink  className="nav-link active text-white" href="#start"><img className={classnames("logo", {"logo-sm": !this.state.visible})} src={Logo} alt="Logo" /></AnchorLink >
            </div>
        <nav id="navBar" role="navigation">
            <ul className="nav d-flex align-items-center">
              <li onClick={CloseNavMobile}  className="nav-item"><AnchorLink  className="nav-link active text-white" href='#about'>Over</AnchorLink ></li>
              <li onClick={CloseNavMobile}  className="nav-item"><AnchorLink  className="nav-link active text-white" href='#schedule'>Schema</AnchorLink ></li>
              <li onClick={CloseNavMobile}  className="nav-item"><AnchorLink  className="nav-link active text-white" href='#media'>Media</AnchorLink ></li>
              <li onClick={CloseNavMobile}  className="nav-item"><AnchorLink  className="nav-link active text-white" href='#location'>Locatie</AnchorLink ></li>
              <li onClick={CloseNavMobile}  className="nav-item"><AnchorLink  className="nav-link active text-white" href='#contact'>Contact</AnchorLink ></li>
            <Flags/>
            </ul>
        </nav>
        <div className={classnames("ToStart--hidden", {"ToStart p-1 border rounded": !this.state.visible})}>
        <AnchorLink  className="nav-link active text-white" href="#start"><FontAwesomeIcon className="text-white fa-2x text-dark" icon={faChevronUp}/></AnchorLink>
        </div>
        <div id="burgerMenu" onClick={ShowNavMobile} className="hidden">
          <FontAwesomeIcon className="text-white fa-2x" icon={ faBars }/>
        </div>
        <div id="NavMobile" className="hidden bg-black">
          <div>
            <AnchorLink  className="nav-link active text-white" href="#start"><img className={classnames("logo", {"logo-sm": !this.state.visible})} src={Logo} alt="Logo" /></AnchorLink >
            </div>
          <ul>
              <li onClick={CloseNavMobile}  className="nav-item"><AnchorLink  className="nav-link active text-white" href='#about'>Over</AnchorLink ></li>
              <li onClick={CloseNavMobile}  className="nav-item"><AnchorLink  className="nav-link active text-white" href='#schedule'>Schema</AnchorLink ></li>
              <li onClick={CloseNavMobile}  className="nav-item"><AnchorLink  className="nav-link active text-white" href='#media'>Media</AnchorLink ></li>
              <li onClick={CloseNavMobile}  className="nav-item"><AnchorLink  className="nav-link active text-white" href='#location'>Locatie</AnchorLink ></li>
              <li onClick={CloseNavMobile}  className="nav-item"><AnchorLink  className="nav-link active text-white" href='#contact'>Contact</AnchorLink ></li>
              <Flags  onClick={CloseNavMobile}/>
              <li onClick={CloseNavMobile} className="bg-white nav-link mt-3">Close</li>
          </ul>
        </div>
    </div>
   
)
}
}
export default React.memo(Nav)


